<template>
	<div id="pt330" class="pt330" v-cloak>
		<breadcrumb :decriptPage="$t('pt330.labels.title')"></breadcrumb>
		<div hidden>
			<!-- 名前 姓 -->
			<label id="name_lbl"> {{$t('pt330.labels.nameLbl')}}</label>
			<!-- 名前 名 -->
			<label id="name2_lbl"> {{$t('pt330.labels.name2Lbl')}}</label>
			<!-- 名前（フリガナ） 姓 -->
			<label id="kanaNm_lbl"> {{$t('pt330.labels.kanaNmLbl')}}</label>
			<!-- 名前（フリガナ） 名 -->
			<label id="kanaNm2_lbl"> {{$t('pt330.labels.kanaNm2Lbl')}}</label>
			<!-- 市区町村 -->
			<label id="address1_lbl"> {{$t('pt330.labels.address1Lbl')}}</label>
			<!-- 番地以下 -->
			<label id="address2_lbl"> {{$t('pt330.labels.address2Lbl')}}</label>
			<!-- マンション名等 -->
			<label id="address3_lbl"> {{$t('pt330.labels.address3Lbl')}}</label>
			<!-- メールアドレス -->
			<label id="mail_lbl"> {{$t('common.labels.mailAddress')}}</label>
			<!-- 電話番号 -->
			<label id="tel_lbl"> {{$t('common.labels.phoneNumber')}}</label>
			<!-- 会社名 -->
			<label id="kaisyaNm_lbl"> {{$t('pt330.labels.kaisyaNmLbl')}}</label>
			<!-- 会社名 フリガナ -->
			<label id="kaisyaKana_lbl"> {{$t('pt330.labels.kaisyaKanaLbl')}}</label>
			<!-- 部署名 -->
			<label id="busyoNm_lbl"> {{$t('pt330.labels.busyoNmLbl')}}</label>
			<!-- 注文番号 -->
			<label id="orderCd_lbl"> {{$t('pt430.labels.orderNo')}}</label>
			<!-- お問合わせ内容 -->
			<label id="contents_lbl"> {{$t('pt330.labels.contentsLbl')}}</label>
		</div>
		<div class="section-inner">
			<div class="itemTitle">
				<h3> {{$t('pt330.labels.inquiryForm')}}</h3>
			</div>
			<!--送信完了時 -->
			<template v-if="dispalyFlag == 1 || dispalyFlag == 0">
				<ul class="flowchart">
					<!-- 項目の入力 -->
					<li>{{$t('pt330.labels.inputItem')}}</li>
					<!-- 送信完了 -->
					<li class="flow-current">{{$t('pt330.labels.contentSendCompletely')}}</li>
				</ul>
				<span v-html="descriptionInfo[3]"></span>
			</template>
			<!--問合せ入力時 -->
			<template v-else>
				<ul class="flowchart">
					<!-- 項目の入力 -->
					<li class="flow-current">{{$t('pt330.labels.inputItem')}}</li>
					<!-- 送信完了 -->
					<li>{{$t('pt330.labels.contentSendCompletely')}}</li>
				</ul>
				<span v-html="descriptionInfo[1]"></span>
				<span v-html="descriptionInfo[2]"></span>
				<!--エラーメッセージ表示 -->
				<template v-if="errorMessage">
					<div class="error-message">
						<p>{{$t('pt330.labels.content4')}}</p>
					</div>
					<message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="PT330_PART"/>
				</template>
				<input type="hidden" name="itemNo" value="">
				<input type="hidden" name="pt330ProcessType" id="pt330ProcessType" value="">
				<!-- エラーメッセージ表示 ここから -->
				<table>
				<template>
					<tr>
						<!-- 名前 -->
						<th v-if="pt330doInit.loginFlg"><label for="form-lastName">{{$t('sh060.labels.name')}}</label></th>
						<th v-else class="required"><label for="form-lastName">{{$t('sh060.labels.name')}}</label></th>
						<td v-if="pt330doInit.loginFlg">
							{{PT330QmailPartsReqModel.name}}{{PT330QmailPartsReqModel.name2}}
						</td>
						<td v-else>
							<div>
								<!-- 姓 -->
								<label for="form-lastName">{{$t('pt330.labels.surname')}}</label>
								<input-check v-model="PT330QmailPartsReqModel.name" maxlength="20" size="12" id="name" type="text" />
								<!-- 名 -->
								<label v-if="pt330doInit.name2Flg == 1" for="form-firstName">{{$t('pt330.labels.name2')}}</label>
								<input-check v-if="pt330doInit.name2Flg == 1" v-model="PT330QmailPartsReqModel.name2" maxlength="20" size="12" id="name2" type="text"/>
							</div>
							<span class="ex" v-html="descriptionInfo[4]"></span>
						</td>
					</tr>
					<tr>
						<!-- 名前（フリガナ） -->
						<th v-if="pt330doInit.loginFlg"><label for="form-lastNameKana">{{$t('pt330.labels.required3')}}</label></th>
						<th v-else class="optional"><label for="form-lastNameKana">{{$t('pt330.labels.required3')}}</label></th>
						<td v-if="pt330doInit.loginFlg">
							{{PT330QmailPartsReqModel.kanaNM}}{{PT330QmailPartsReqModel.kanaNM2}}
						</td>
						<td v-else>
							<div>
								<!-- 姓 -->
								<label for="form-lastNameKana">{{$t('pt330.labels.surname')}}</label>
								<input-check v-model="PT330QmailPartsReqModel.kanaNM" size="14" maxlength="20" id="kanaNm" type="text" />
								<!-- 名 -->
								<label v-if="pt330doInit.name2Flg == 1" for="form-firstNameKana">{{$t('pt330.labels.name2')}}</label>
								<input-check v-if="pt330doInit.name2Flg == 1" v-model="PT330QmailPartsReqModel.kanaNM2" size="14" maxlength="20" id="kanaNm2" type="text" />
							</div>
							<span class="ex" v-html="descriptionInfo[5]"></span>
						</td>
					</tr>
					<tr>
						<!-- 郵便番号 -->
						<th v-if="pt330doInit.loginFlg"><label for="zip" id="zip_lbl">{{$t('pt330.labels.required6')}}</label></th>
						<th v-else class="optional"><label for="zip" id="zip_lbl">{{$t('pt330.labels.required6')}}</label></th>
						<td v-if="pt330doInit.loginFlg">
							{{PT330QmailPartsReqModel.zip}}
						</td>
						<td v-else>
							<div>
								<input-check v-model="PT330QmailPartsReqModel.zip" maxlength="8" size="12" class="zip" id="zip" type="text" />
								<!-- 住所検索 -->
								<button class="btnSubmit" @click="addrAutoInput()">{{$t('pt330.buttons.addressSearch')}}</button>
							</div>
							<span class="ex" v-html="descriptionInfo[6]"></span>
						</td>
					</tr>
	                <!--都道府県 プルダウン設定オプション-->
					<tr class="kenLine" v-if="pt330doInit.kenPulldownDispFlg == 1">
                        <th v-if="pt330doInit.loginFlg">
                            <label id="kenCd_lbl">
                                <span>{{$t('common.labels.prefectures')}}</span>
                            </label>
                        </th>
						<th v-else class="optional">
                            <label id="kenCd_lbl">
                                <span>{{$t('common.labels.prefectures')}}</span>
                            </label>
                        </th>
						<td v-if="pt330doInit.loginFlg">
							{{PT330QmailPartsReqModel.kenNm}}
						</td>
                        <td v-else>
                            <select v-model="PT330QmailPartsReqModel.kokyakuKenCd" class="kenCdSelect" id="kenCd" name="kenCd"> 
                                <option v-for="kenCd in pt330doInit.kenList" :key="kenCd.KEY" :value="kenCd.KEY">{{kenCd.VALUE}}</option>
                            </select>
                        </td>
                    </tr>
					<!--都道府県CD-->
					<input type="hidden" v-model="PT330QmailPartsReqModel.kokyakuKenCd" />
					<tr>
						<!-- 市区郡町村 -->
						<th v-if="pt330doInit.loginFlg"><label for="form-address1">{{$t('pt330.labels.required8')}}</label></th>
						<th v-else class="optional"><label for="form-address1">{{$t('pt330.labels.required8')}}</label></th>
						<td v-if="pt330doInit.loginFlg">
							{{PT330QmailPartsReqModel.address1}}
						</td>
						<td v-else>
							<input-check v-model="PT330QmailPartsReqModel.address1" maxlength="50" size="50" id="address1" type="text" />
							<span v-if="pt330doInit.kenPulldownDispFlg == 1" class="ex" v-html="descriptionInfo[8]"></span>
							<span v-else class="ex" v-html="descriptionInfo[19]"></span>
						</td>
					</tr>
					<tr>
						<!-- 番地以下 -->
						<th v-if="pt330doInit.loginFlg"><label for="form-address2">{{$t('pt330.labels.required11')}}</label></th>
						<th v-else class="optional"><label for="form-address2">{{$t('pt330.labels.required11')}}</label></th>
						<td v-if="pt330doInit.loginFlg">
							{{PT330QmailPartsReqModel.address2}}
						</td>
						<td v-else>
							<input-check v-model="PT330QmailPartsReqModel.address2" maxlength="50" size="50" id="address2" type="text" />
							<span class="ex" v-html="descriptionInfo[18]"></span>
						</td>
					</tr>
					<tr>
						<!-- マンション名・会社名等 -->
						<th v-if="pt330doInit.loginFlg"><label for="form-address3">{{$t('pt330.labels.optionLabel')}}</label></th>
						<th v-else class="optional"><label for="form-address3">{{$t('pt330.labels.optionLabel')}}</label></th>
						<td v-if="pt330doInit.loginFlg">
							{{PT330QmailPartsReqModel.address3}}
						</td>
						<td v-else>
							<input-check v-model="PT330QmailPartsReqModel.address3" maxlength="50" size="50" id="address3" type="text" />
							<span class="ex" v-html="descriptionInfo[9]"></span>
						</td>
					</tr>
					<tr>
						<!-- メールアドレス -->
						<th v-if="pt330doInit.loginFlg"><label for="PT330Mail">{{$t('pt330.labels.required9')}}</label></th>
						<th v-else class="required" rowspan="1"><label for="PT330Mail">{{$t('pt330.labels.required9')}}</label></th>
						<td v-if="pt330doInit.loginFlg">
							{{PT330QmailPartsReqModel.mail}}
						</td>
						<td v-else>
							<input-check v-model="PT330QmailPartsReqModel.mail" maxlength="80" size="26" class="mail" id="mail" type="text" />
							<br>
							<span class="ex" v-html="descriptionInfo[10]"></span>
						</td>
					</tr>
					<tr v-if="!pt330doInit.loginFlg">
						<th class="required"><label for="PT330Mail">{{$t('common.labels.mailAddressConfirm')}}</label></th>
						<td>
							<input-check v-model="PT330QmailPartsReqModel.mailKaku"  size="26" class="mail" maxlength="80" id="mailKaku"  type="text"/>
							<br>
							<span v-html="descriptionInfo[11]"></span>
						</td>
					</tr>
					<tr>
						<!-- 電話番号 -->
						<th v-if="pt330doInit.loginFlg"><label for="tel">{{$t('common.labels.phoneNumber')}}</label></th>
						<th v-else class="optional"><label for="tel">{{$t('common.labels.phoneNumber')}}</label></th>
						<td v-if="pt330doInit.loginFlg">
							{{PT330QmailPartsReqModel.tel}}
						</td>
						<td v-else>
							<input-check v-model="PT330QmailPartsReqModel.tel" size="18" class="tel" id="tel" type="text" />
							<span class="ex" v-html="descriptionInfo[12]"></span>
						</td>
					</tr>
					<tr>
						<!-- FAX番号 -->
						<th v-if="pt330doInit.loginFlg"><label for="fax">{{$t('pt330.labels.fax')}}</label></th>
						<th v-else class="optional"><label for="fax">{{$t('pt330.labels.fax')}}</label></th>
						<td v-if="pt330doInit.loginFlg">
							{{PT330QmailPartsReqModel.fax}}
						</td>
						<td v-else>
							<input-check v-model="PT330QmailPartsReqModel.fax" class="tel" size="18"  id="fax" type="text" />
							<span class="ex" v-html="descriptionInfo[13]"></span>
						</td>
					</tr>
					<tr>
						<!-- 件名 -->
						<th class="required"><label for="mailSubject" id="mailTitle_lbl">{{$t('pt330.labels.mailSubject')}}</label></th>
						<td>
							<div>
								<!-- 件名 -->
								<input-check v-model="PT330QmailPartsReqModel.mailTitle" size="26" maxlength="300" class="multi" id="mailTitle" type="text" />
							</div>
							<span class="ex" v-html="descriptionInfo[16]"></span>
						</td>
					</tr>
				</template>
				<!-- BtoCの場合 ここまで -->
					<tr>
						<!-- お問い合わせ内容 -->
						<th class="required"><label for="PT330Contents" id="contents_lbl">{{$t('pt330.labels.required10')}}</label></th>
						<td>
							<input-check v-model="PT330QmailPartsReqModel.contents"  rows="10" cols="50" :classify="'textarea'" class="multi" name="contents" type="text" />
							<br>
							<span v-html="descriptionInfo[17]"></span>
						</td>
					</tr>
					<tr v-if="pt330doInit.useImageRequestFlg == 1">
						<!-- 商品画像利用希望 -->
						<th class="optional"><label for="PT330UseImageRequest" id="PT330UseImageRequest_lbl">{{$t('pt330.labels.useImageRequest')}}</label></th>
						<td>
							<div class="useImageRequestCheckArea form-inline">
								<input type="checkbox" v-model="PT330QmailPartsReqModel.useImageRequestCheck" @change="changeImageRequestCheck()" id="useImageRequestCheck" class="useImageRequestCheck mr-1">
								<label for="useImageRequestCheck" class="useImageRequestLbl">{{$t('pt330.labels.useImageRequestLbl')}}</label>
							</div>
							<span v-html="descriptionInfo[21]"></span>

							<!-- 商品画像利用規約 -->
							<template v-if="PT330QmailPartsReqModel.useImageRequestCheck">
								<label class="PT330itemImgToUTitle">{{$t('pt330.labels.PT330itemImgToUTitle')}}</label>
								<span class="PT330itemImgToUContents" v-html="descriptionInfo[20]" ></span>
								<div class="PT330itemImgToUAgreeFlag form-inline">
									<input type="radio" id="AgreeFlag1" name="AgreeFlag" value="1" class="AgreeFlag1Input mr-1" v-model="useImageRequestAgree">
									<label for="AgreeFlag1">{{$t('pt330.labels.agreeItems')}}</label>
									<input type="radio" id="AgreeFlag0" name="AgreeFlag" value="0" class="AgreeFlag0Input mr-1" v-model="useImageRequestAgree">
									<label for="AgreeFlag0">{{$t('pt330.labels.dontAgree')}}</label>
								</div>
							</template>
						</td>
						
					</tr>
				</table>
				<div>
					<!-- この内容を送信する (非活性) -->
					<a class="btnCancel" @click="agreeErrMsg()" v-if="pt330doInit.useImageRequestFlg == 1 && PT330QmailPartsReqModel.useImageRequestCheck && useImageRequestAgree == 0">
						{{$t('pt330.buttons.sendMail')}}
					</a>
					<!-- この内容を送信する -->
					<a class="btnSubmit" @click="confirmSendMail()" v-else>{{$t('pt330.buttons.sendMail')}}</a>
				</div>
			</template>
			<alert-confirm 
				v-if="isModalShow"
				:msgConfirm="msgConfirm"
				:isButtonCancel="isButtonCancel"
				:okAction="sendMail"
				@closedModal="isModalShow = false"
				:isButtonOK="isButtonOK">
			</alert-confirm>
			<CC212 v-if="cc212Dislay" :propTdkZip1 ="dataCc212.propTdkZip1" @modal-close="cc212Dislay=false" :propTdkZip2 ="dataCc212.propTdkZip2" @set-addr-value="selectData" ></CC212>
		</div>
	</div>
</template>

<script>

import common from "assets/js/common";
import axios from "assets/js/request";
import InputCheck from 'components/InputCheck';
import AlertConfirm from 'components/AlertConfirm';
import Message from 'components/MessageEcSite';
import SiteConstants from 'assets/const/SiteConstants.json';
import EventBus from 'assets/js/eventBus';
import CC212 from '../search/CC212InputPostal.vue';
import Breadcrumb from "../commonParts/Breadcrumb.vue";

export default {
	name: 'PT330QmailParts',
    props:{
        ptInitData: {
            type: Object,
            default: null,
        },
    },
	components: {
		InputCheck,
		AlertConfirm,
		Message,
		CC212,
		Breadcrumb
	},

    data() {
        return {
            PT330QmailPartsReqModel:{
            },
			pt330doInit: {
				descriptionInfo:{},
				name2Flg: 0,
				useImageRequestFlg: 0,
				loginFlg: false
			},
            lstMailTitel:[],
            kenList:[],
			dispalyFlag:null,
			pt330MailDes : null,
			pt330ContentsDes:null,
			cc212ReqModel:{},
			isModalShow:false,
			msgConfirm:null,
			errorMessage:false,
			descriptionInfo:[],
			listIdErr:[],
            listMessValid:[],
			mapMessValid:[],
			PT330_PART:'pt330',
			SiteConstants:SiteConstants,
			isButtonCancel:false,
			isButtonOK:false,
			cc212Dislay:false,
			cc211Dislay:false,
			dataCc212: {},
			itemNm:null,
			useImageRequestCheck:false,
			useImageRequestAgree:0
        }
    },
    mounted() {
        var _this = this;
		common.clearMessageEcSite(_this.listIdErr, _this.PT330_PART);

		if (_this.ptInitData){
			_this.pt330doInit = _this.ptInitData;
			_this.PT330QmailPartsReqModel = _this.ptInitData.reqModel;
			_this.lstMailTitel = _this.ptInitData.lstMailTitel;
			_this.kenList = _this.ptInitData.kenList;
			_this.descriptionInfo = _this.pt330doInit.descriptionInfo;
			if ( _this.itemNm != null && _this.itemNm != undefined) {
				_this.itemNm =  _this.itemNm + _this.$i18n.t('common.labels.qmailMessage');
			}
			_this.PT330QmailPartsReqModel.mailTitle = _this.itemNm;
			_this.errorMessage = false;
		}else{
			axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT330 + _this.$UrlConstants.DO_INIT, _this.PT330QmailPartsReqModel).then(function(response) {
				_this.pt330doInit = response.data;
				_this.PT330QmailPartsReqModel = response.data.reqModel;
				_this.lstMailTitel = response.data.lstMailTitel;
				_this.kenList = response.data.kenList;
				_this.descriptionInfo = _this.pt330doInit.descriptionInfo;
				if ( _this.itemNm != null && _this.itemNm != undefined) {
					_this.itemNm =  _this.itemNm + _this.$i18n.t('common.labels.qmailMessage');
				}
				_this.PT330QmailPartsReqModel.mailTitle = _this.itemNm;
				_this.errorMessage = false;
			}).catch(function(error) {
				common.errorAPI(error);
			});
		}
		EventBus.$on('closed', function(){
				_this.isModalShow = false;
				_this.cc212Dislay = false;
		});
	},
	methods: {
        // goto pg030
        sendMail: function(){
			var _this = this;
			_this.listMessValid = [];
			_this.mapMessValid = [];
			common.clearMessageEcSite(_this.listIdErr, _this.PT330_PART);
			if (_this.PT330QmailPartsReqModel.kanaNM == null){
				_this.PT330QmailPartsReqModel.kanaNM="";
			}
			if (_this.PT330QmailPartsReqModel.kanaNM2 == null){
				_this.PT330QmailPartsReqModel.kanaNM2="";
			}
			if (_this.PT330QmailPartsReqModel.kaisyaKana == null){
				_this.PT330QmailPartsReqModel.kaisyaKana ="";
			}
			_this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT330 + _this.$UrlConstants.DO_SEND_MAIL, _this.PT330QmailPartsReqModel).then(function(response) {
				if(response.data.resultResponse.status == "OK"){
					_this.dispalyFlag = response.data.dispalyFlag;
				}
				_this.isModalShow = false;
				_this.$emit("event-loading", false);
			}).catch(function(error) {
				_this.$emit("event-loading", false);
				_this.errorMessage = true;
				if(error != null && error != undefined){
					_this.isModalShow = false;
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.PT120_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
				}
				common.scrollTop();
			});
		},
		confirmSendMail: function(){
			var _this = this;
			_this.isModalShow = true;
			// 入力した内容でお問合わせメールを送信します。よろしいですか？
			_this.msgConfirm =_this.$i18n.t('pt330.labels.confirmSendMail');
			_this.isButtonCancel=true;
			_this.isButtonOK=true;
		},
		//住所自動入力
		addrAutoInput: function(){
			var _this = this;
			var zip = _this.PT330QmailPartsReqModel.zip;
			// 郵便番号未入力の場合
			if(zip == '' || zip == null || zip == undefined) {
				if (_this.isModalShow != true){
					_this.isModalShow = true;
				}
				// 郵便番号は必須です。
				_this.msgConfirm =_this.$i18n.t('sh030.labels.zipCodeIsMandatory');
				_this.isButtonCancel=true;
				_this.isButtonOK=false;
				return;
			}
			var zipArr = zip.split("-");
			var zip1 = "";
			var zip2 = "";
			if (zipArr.length == 2) {
				zip1 = zipArr[0];
				zip2 = zipArr[1];
			}else{
				zip1 = zip.substr(0,3);
				zip2 = zip.substr(3);
			}
			_this.cc212ReqModel.tdkZip1 = zip1;
			_this.cc212ReqModel.tdkZip2 = zip2;
			_this.$emit("event-loading", true);
			axios.post(_this.$UrlConstants.POPUP + _this.$UrlConstants.CC212 + _this.$UrlConstants.GET_ADDR_INFO, _this.cc212ReqModel).then(function(response) {
				if (response.data.allAddr == 'juufuku'){
					_this.dataCc212.propTdkZip1 = zip1;
					_this.dataCc212.propTdkZip2 = zip2;
					_this.cc212Dislay = true;
				}
				else {
					_this.setAddr(response.data.allAddr ,response.data.kenCd ,response.data.kenNm, zip1 ,zip2);
				}
				_this.$emit("event-loading", false);
			}).catch(function(error) {
				_this.$emit("event-loading", false);
				common.errorAPI(error);
			});
		},
		// 住所検索Ajaxの戻り
		// パラメータの_addrに「住所,町名番地,建物名・部屋番号」の形で戻ってくる(30文字ずつ)
		setAddr: function (addr, kenCd ,kenNm , zip1 , zip2){
			var _this = this;
			if (addr) {
				//都道府県のプルダウンを使用しない場合
				if(_this.pt330doInit.kenPulldownDispFlg == 0){
					_this.PT330QmailPartsReqModel.address1 = kenNm + addr.replace(",", "");
				}else{
					_this.PT330QmailPartsReqModel.address1 = addr.replace(",", "");
				}
				_this.PT330QmailPartsReqModel.kokyakuKenCd = kenCd;
				_this.PT330QmailPartsReqModel.zip = zip1+ "-" +zip2;
				_this.$forceUpdate();
			}else{
				if (_this.isModalShow != true){
					_this.isModalShow = true;
				}
				// 郵便番号が存在しません
				_this.msgConfirm =_this.$i18n.t('sh030.labels.zipCodeDoesNotExist');
				_this.PT330QmailPartsReqModel.zip= '';
				_this.isButtonCancel=true;
				_this.isButtonOK=false;
			}
		},
		// 商品画像利用チェックを変更した場合
		changeImageRequestCheck() {
			var _this = this;
			// チェックが外れた場合、同意しないへりセット
			if (!_this.PT330QmailPartsReqModel.useImageRequestCheck) {
				_this.useImageRequestAgree = 0;
			}
		},
		// 商品画像利用規約に同意していない場合
		agreeErrMsg() {
			var _this = this;
			// 商品画像利用規約に同意してください。
			_this.msgConfirm =_this.$i18n.t('pt330.labels.agreeErrMsg');
			_this.isModalShow = true;
			_this.isButtonCancel=true;
			_this.isButtonOK=false;
		},
		selectData(value){
			var _this = this;
			_this.PT330QmailPartsReqModel.address1 = value.addr.ALL_ADDR.replace(",", "");  
			_this.PT330QmailPartsReqModel.kokyakuKenCd = value.addr.KEN_CD;
			var zip = value.addr.PSTNO;
			var zipArr = zip.split("-");
			var zip1 = "";
			var zip2 = "";
			if (zipArr.length == 2) {
				zip1 = zipArr[0];
				zip2 = zipArr[1];
			}else{
				zip1 = zip.substr(0,3);
				zip2 = zip.substr(3);
			}
			_this.PT330QmailPartsReqModel.zip = zip1+ "-" +zip2;

            //都道府県のプルダウンを使用しない場合
            if(_this.pt330doInit.kenPulldownDispFlg == 1){
                _this.PT330QmailPartsReqModel.address1 = _this.outKenNm(_this.PT330QmailPartsReqModel.kokyakuKenCd,_this.PT330QmailPartsReqModel.address1);
            }
            _this.isCCInputPostalShow = false;
			_this.$forceUpdate();
		},
		/*
        * 都道府県名を削除
        */
        outKenNm :function(kenCd,addr) {
            var kenList = this.pt330doInit.kenList;
            for ( var i = 0; kenList.length > i; i++) {
                if(kenList[i].KEY == kenCd) {
                    return  addr.replace(kenList[i].VALUE,"");
                }
            }
		},
	},
	created: function(){
         var _this = this;
        // Get data from params and query
        var paramData = _this.$route.params;
        var queryData = _this.$route.query;
        if(Object.keys(paramData).length > 0){
            if(!common.isNullItem(paramData.itemNm))
                _this.itemNm = paramData.itemNm;
        }
        if(Object.keys(queryData).length > 0){
            if(!common.isNullItem(queryData.itemNm))
                _this.itemNm = queryData.itemNm;
        }
    }
}
</script>
